import { motion } from "framer-motion";
import CountUp from "react-countup";
import SattvaFootPrint from "../../assets/images/home-page/MAP1.svg"

const SattvaPresence = () => {
    const stats = [
        {
            value: 5,
            suffix: "+",
            title: "Countries",
            description: "Clients and Partners",
        },
        {
            value: 100000,
            suffix: "+",
            title: "Stakeholders",
            description: "Supported globally",
        },
        // {
        //     value: 250,
        //     suffix: "+",
        //     title: "ESG Metrics",
        //     description: "Preset & custom ESG data points",
        // },
    ];
    return (
        <article className="relative py-16 bg-gradient-to-r from-green-600/50 dark:from-green-600/60 via-green-600/10 dark:via-green-600/20 to-transparent">

            <section className=" container flex flex-col md:flex-row max-md:gap-y-3 items-center justify-center h-fit mx-auto rounded-lg gap-[2%]" >
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7 }}
                    viewport={{ once: true }}
                    className="text-white"
                >
                    <h6 className="text-blue-600 text-base font-medium uppercase mb-2">Global ESG Presence</h6>
                    {/* <p className="text-sm uppercase tracking-widest text-green-300">
                        Global ESG Presence
                    </p> */}

                    <h3 className="mb-4 md:text-2xl text-xl font-medium text-black dark:text-white">
                        End-to-End ESG Solution
                    </h3>

                    <p className="text-slate-500 dark:text-slate-300 max-w-xl">
                        SATTVA enables organizations to centralize ESG data,
                        generate AI-driven insights, and automatically produce
                        buyer- and standards-ready sustainability reports.
                    </p>

                    {/* STAT CARDS */}
                    <div className="grid sm:grid-cols-3 gap-4 pt-6">
                        {stats.map((stat, index) => (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.2 }}
                                viewport={{ once: true }}
                                className="bg-white/70 backdrop-blur-md rounded-xl p-5 border border-white/10"
                            >
                                <h3 className="text-2xl font-bold text-green-500">
                                    <CountUp
                                        end={stat.value}
                                        duration={2}
                                        separator=","
                                    />
                                    {stat.suffix}
                                </h3>
                                <span className="text-md text-slate-500">
                                    {stat.title}
                                </span>
                                <p className="text-sm text-slate-500 mt-1">
                                    {stat.description}
                                </p>
                                
                            </motion.div>
                        ))}
                    </div>
                </motion.div>

                {/* RIGHT MAP */}
                <motion.div
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="relative"
                >
                    <img
                        src={SattvaFootPrint}
                        alt="Sattva Global Presence"
                        className="w-full max-w-2xl mx-auto opacity-90"
                    />

                    {/* Decorative glow */}
                    <div className="absolute inset-0 bg-green-400/10 blur-3xl rounded-full -z-10" />
                </motion.div>
            </section>
        </article>
    )
}

export default SattvaPresence